// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Hover from "../../primitives/Hover.res.js";
import * as React from "react";
import * as Inline from "./Inline.res.js";
import * as Touchable from "../../primitives/Touchable.res.js";
import * as LegacyIcon from "../images-and-icons/LegacyIcon.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as JsxRuntime from "react/jsx-runtime";
function contentViewStyleFromParams(opened) {
  return {
    0: {
      className: "transition-x27dnv7 overflow-xb3r6kr",
      style: {
        opacity: 0,
        height: "0px",
        paddingBlock: "0px"
      },
      "data-style-src": "wino-gc:src/resources/layout-and-structure/Accordion.res.js:16"
    },
    1: {
      className: "transition-x27dnv7 overflow-xb3r6kr",
      style: {
        opacity: 1,
        paddingTop: "4px"
      },
      "data-style-src": "wino-gc:src/resources/layout-and-structure/Accordion.res.js:16"
    }
  }[!!opened << 0];
}
function Accordion(props) {
  let onToggle = props.onToggle;
  let match = React.useState(() => false);
  let setOpened = match[1];
  let opened = match[0];
  let match$1 = Hover.use(undefined, undefined, undefined);
  let onPress = param => {
    setOpened(param => !opened);
    if (onToggle !== undefined) {
      return onToggle(!opened);
    }
  };
  let tmp;
  if (opened) {
    let newrecord = {
      ...{
        className: "display-x78zum5 paddingInline-x3y1lgt",
        "data-style-src": "wino-gc:src/resources/layout-and-structure/Accordion.res.js:12"
      }
    };
    tmp = JsxRuntime.jsxs(Inline.make, {
      children: [JsxRuntime.jsx("div", (newrecord.children = JsxRuntime.jsx(LegacyIcon.make, {
        name: "arrow_up_light"
      }), newrecord)), props.triggerHideView]
    });
  } else {
    let newrecord$1 = {
      ...Stylex.props({
        borderBottomColor: match$1[1] ? "#d7d7e0" : "transparent",
        borderBottomStyle: "solid",
        borderBottomWidth: "1px"
      })
    };
    let newrecord$2 = {
      ...{
        className: "display-x78zum5 paddingInline-x3y1lgt",
        "data-style-src": "wino-gc:src/resources/layout-and-structure/Accordion.res.js:12"
      }
    };
    newrecord$1.children = JsxRuntime.jsxs(Inline.make, {
      children: [JsxRuntime.jsx("div", (newrecord$2.children = JsxRuntime.jsx(LegacyIcon.make, {
        name: "arrow_down_light"
      }), newrecord$2)), props.triggerShowView]
    });
    tmp = JsxRuntime.jsx("div", newrecord$1);
  }
  let newrecord$3 = {
    ...contentViewStyleFromParams(opened)
  };
  return JsxRuntime.jsxs("div", {
    children: [JsxRuntime.jsx(Inline.make, {
      children: JsxRuntime.jsx(Touchable.make, {
        children: tmp,
        onPress: onPress,
        ref: match$1[0]
      })
    }), JsxRuntime.jsx("div", (newrecord$3.children = props.children, newrecord$3))]
  });
}
let make = React.memo(Accordion);
export { make };
/* styles Not a pure module */